<template>
  <div>
    <p class="attention">※20文字以内</p>
    <v-text-field
      class="input-exam ma-0"
      v-model="selectedTitle"
      color="secondary"
      :rules="rules"
      outlined
      dense
    />
  </div>
</template>

<script>
export default {

  data() {
    return {
      inittialPrintTitle: this.$store.state.user.classroomName,
      rules: [v => !v || v.length <= 20 || '20文字以内で入力してください',]
    }
  },

  mounted() {
    // プリント名の初期値として自分の教室名を入れる
    if (this.$store.state.conditions.printTitle === undefined) {
      this.$store.commit('conditions/setPrintTitle', { printTitle: this.inittialPrintTitle })
    }
  },

  computed: {
    selectedTitle: {
      get() {
        return this.$store.state.conditions.printTitle
      },
      set(value) {
        this.$store.commit('conditions/setPrintTitle', {
          printTitle: value
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.select-exam
  margin-top 30px
  width 300px
.input-exam
  margin-top 40px
  width 300px
.attention
  font-size 12px
</style>>
